/* ============================================================================
   ag-precart-modal.js
   Extracted from sections/ag-precart-modal.liquid on 2026-04-16
   Post-ATC "Style With" modal — intercepts product:added event,
   fetches gender-aware styled-with collection, renders cross-sell grid.
   Currency symbol read from modal's data-currency-symbol attribute.
   ============================================================================ */

(function() {
  var modal = document.getElementById('ag-precart-modal');
  if (!modal) return;

  var itemEl = document.getElementById('ag-precart-item');
  var gridEl = document.getElementById('ag-precart-grid');
  var womensHandle = modal.dataset.womensHandle;
  var mensHandle = modal.dataset.mensHandle;

  window.agPrecartClose = function() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ag-precart-locked');
    document.documentElement.classList.remove('no-scroll');
  };

  window.agPrecartGoToCart = function() {
    agPrecartClose();
    setTimeout(function() {
      var overlay = document.querySelector('.PageOverlay');
      var cart = document.getElementById('sidebar-cart');
      if (overlay) overlay.classList.add('is-visible');
      if (cart) cart.setAttribute('aria-hidden', 'false');
    }, 250);
  };

  window.agPrecartTryOpen = function(lineItem, onFallback) {
    var fallback = onFallback || function() {};
    if (!lineItem || !lineItem.handle) { fallback(); return; }

    fetch('/products/' + lineItem.handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var tags = (product.tags || []).map(function(t) { return (t || '').toLowerCase(); });
        var handle = tags.some(isWomens) ? womensHandle : tags.some(isMens) ? mensHandle : null;
        if (!handle) { fallback(); return; }

        return fetch('/collections/' + handle + '/products.json?limit=10')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.products || []).filter(function(p) { return p.handle !== product.handle; });
            if (!products.length) { fallback(); return; }
            open(product, lineItem, products);
          });
      })
      .catch(fallback);
  };

  function isWomens(t) { return t === 'women' || t === 'womens' || t === 'womenswear'; }
  function isMens(t) { return t === 'men' || t === 'mens' || t === 'menswear'; }

  function open(product, lineItem, products) {
    renderItem(product, lineItem);
    renderGrid(products);
    /* Fire cart:refresh so Prestige re-renders the drawer contents in the background —
       when user clicks Continue to Cart, the drawer will have the just-added item */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    /* Close cart drawer if Prestige opened it + release their scroll lock */
    var overlay = document.querySelector('.PageOverlay');
    var cart = document.getElementById('sidebar-cart');
    if (overlay) overlay.classList.remove('is-visible');
    if (cart) cart.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ag-precart-locked');
  }

  function renderItem(product, lineItem) {
    var variant = product.variants.find(function(v) { return v.id === lineItem.variant_id; }) || product.variants[0];
    var title = variant.title !== 'Default Title' ? variant.title : '';
    var img = product.featured_image || lineItem.image || lineItem.featured_image || '';
    if (img && typeof img === 'object') img = img.src || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    itemEl.innerHTML =
      '<img class="ag-precart__item-img" src="' + img + '" alt="' + esc(product.title) + '">' +
      '<div class="ag-precart__item-info">' +
        '<h3 class="ag-precart__item-title">' + esc(product.title) + '</h3>' +
        (title ? '<span class="ag-precart__item-variant">' + esc(title) + '</span>' : '') +
      '</div>' +
      '<span class="ag-precart__item-price">' + money(lineItem.price / 100) + '</span>';
  }

  function renderGrid(products) {
    gridEl.innerHTML = products.map(card).join('');
  }

  function card(p) {
    var img = (p.images && p.images[0]) || p.featured_image || '';
    /* Some Shopify endpoints return image objects, some strings */
    if (img && typeof img === 'object') img = img.src || '';
    /* Protocol-relative URLs need https */
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var variant = p.variants[0];
    var price = parseFloat(variant.price);
    var compare = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
    var onSale = compare && compare > price;

    var sizeOpt = (p.options || []).find(function(o) { return (o.name || '').toLowerCase() === 'size'; });
    var sizesHtml = '';
    if (sizeOpt) {
      sizesHtml = '<div class="ag-card__sizes">' + sizeOpt.values.map(function(v) {
        var avail = p.variants.find(function(va) { return va.option1 === v && va.available; });
        return avail
          ? '<button type="button" class="ag-card__size" data-variant-id="' + avail.id + '">' + esc(v) + '</button>'
          : '<button type="button" class="ag-card__size ag-card__size--oos" disabled>' + esc(v) + '</button>';
      }).join('') + '</div>';
    }

    return '<div class="ag-card" data-product-handle="' + esc(p.handle) + '">' +
      '<div class="ag-card__image-wrap">' +
        '<a href="/products/' + esc(p.handle) + '" class="ag-card__image-link">' +
          '<img class="ag-card__image ag-card__image--primary" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' +
        '</a>' +
        sizesHtml +
      '</div>' +
      '<div class="ag-card__info">' +
        '<span class="ag-card__subtitle"></span>' +
        '<h3 class="ag-card__title"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="ag-card__price-row">' +
          '<div class="ag-card__price">' +
            (onSale
              ? '<span class="ag-card__price-current ag-card__price-current--sale">' + money(price) + '</span><span class="ag-card__price-compare">' + money(compare) + '</span>'
              : '<span class="ag-card__price-current">' + money(price) + '</span>'
            ) +
          '</div>' +
          '<button type="button" class="ag-card__quick-add" data-ag-quick-add="' + esc(p.handle) + '" aria-label="Quick add">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function money(n) {
    var s = document.getElementById('ag-precart-modal').dataset.currencySymbol || '£';
    return n % 1 === 0 ? s + n.toFixed(0) : s + n.toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Mobile + button inside modal: show size strip over image (not the quick-add modal) */
  gridEl.addEventListener('click', function(e) {
    if (window.innerWidth > 750) return; /* Desktop uses hover */
    var plus = e.target.closest('.ag-card__quick-add');
    if (!plus) return;
    e.preventDefault();
    e.stopPropagation(); /* Prevent the global quick-add handler */
    var card = plus.closest('.ag-card');
    if (!card) return;
    /* Close any other open cards */
    gridEl.querySelectorAll('.ag-card.is-showing-sizes').forEach(function(c) {
      if (c !== card) c.classList.remove('is-showing-sizes');
    });
    card.classList.toggle('is-showing-sizes');
  }, true); /* capture phase to beat the global handler */

  /* Tap outside card → close sizes */
  document.addEventListener('click', function(e) {
    if (modal.getAttribute('aria-hidden') !== 'false') return;
    if (window.innerWidth > 750) return;
    if (e.target.closest('.ag-card')) return;
    gridEl.querySelectorAll('.ag-card.is-showing-sizes').forEach(function(c) {
      c.classList.remove('is-showing-sizes');
    });
  });
})();

/* Intercept Prestige's product:added event BEFORE their listener runs */
(function() {
  if (!document.getElementById('ag-precart-modal')) return;

  document.addEventListener('product:added', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    /* Stop Prestige — we handle drawer opening ourselves, avoiding their disableBodyScroll lock */
    e.stopImmediatePropagation();

    /* If cart drawer is already open (upsell ATC), just refresh cart — don't open precart modal */
    var cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }

    /* Pull latest cart to get full line item (with handle, price, etc) */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var item = cart.items.find(function(i) { return i.variant_id === variant.id; }) || cart.items[cart.items.length - 1];
      if (!item || !item.handle) { openCartDrawer(); return; }
      window.agPrecartTryOpen(item, openCartDrawer);
    }).catch(openCartDrawer);
  }, true);

  function openCartDrawer() {
    /* Re-render cart contents (Prestige listens to this event) */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    /* Small delay so re-render completes before drawer is visible */
    setTimeout(function() {
      var overlay = document.querySelector('.PageOverlay');
      var cart = document.getElementById('sidebar-cart');
      if (overlay) overlay.classList.add('is-visible');
      if (cart) cart.setAttribute('aria-hidden', 'false');
    }, 100);
  }
})();

/* For non-PDP ATCs (size buttons on cards), intercept fetch as before */
(function() {
  if (!document.getElementById('ag-precart-modal')) return;

  var originalFetch = window.fetch;
  window.fetch = function(url) {
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(urlStr)) return originalFetch.apply(this, arguments);

    /* Skip if it's Prestige's fetch — product:added listener will handle it */
    if (arguments[1] && arguments[1].headers && arguments[1].headers['X-Requested-With'] === 'XMLHttpRequest') {
      return originalFetch.apply(this, arguments);
    }

    /* Modal already open — silent add */
    if (modalIsOpen()) {
      return originalFetch.apply(this, arguments).then(function(res) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return res;
      });
    }

    /* Cart drawer already open (upsell ATC) — add silently, refresh cart, stay in drawer */
    var cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
      return originalFetch.apply(this, arguments).then(function(res) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return res;
      });
    }

    return originalFetch.apply(this, arguments).then(function(response) {
      if (!response.ok) return response;
      response.clone().json().then(function(data) {
        var item = data.items ? data.items[0] : data;
        if (!item || !item.handle) { openCartDrawer(); return; }
        window.agPrecartTryOpen(item, openCartDrawer);
      }).catch(openCartDrawer);
      return response;
    });
  };

  function modalIsOpen() {
    var m = document.getElementById('ag-precart-modal');
    return m && m.getAttribute('aria-hidden') === 'false';
  }
  function openCartDrawer() {
    var overlay = document.querySelector('.PageOverlay');
    var cart = document.getElementById('sidebar-cart');
    if (overlay) overlay.classList.add('is-visible');
    if (cart) cart.setAttribute('aria-hidden', 'false');
  }
})();
